import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-500-fill",
  "use": "icon-500-fill-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-500-fill\" viewBox=\"0 0 16 16\" id=\"icon-500-fill\">\n  <path d=\"M7.031 9.208a.5.5 0 0 1 0-1h8.45a3.05 3.05 0 0 0-3.543-2.77 4.675 4.675 0 0 0-7.838 0 3.149 3.149 0 0 0-.397-.04 3.184 3.184 0 1 0 1.244 6.117 4.61 4.61 0 0 0 6.144 0 3.184 3.184 0 0 0 4.365-2.307z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol